import type { ReactNode } from 'react';
import { cn } from './cn';
import { TooltipProvider } from './ui/tooltip';
import './newdesign.css';

/** Граница новой дизайн-системы: токены, шрифт и утилиты `nd:` действуют только внутри. */
export function NewDesignScope({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('nd-root', className)}>
      <TooltipProvider>{children}</TooltipProvider>
    </div>
  );
}
